import { API_BASE_URL } from './api';
import { authService } from './authService';

export interface TagInviteLink {
  tagId: string;
  name: string;
  claimed: boolean;
  code: string;
}

export interface TagInvitePreview {
  authorUserId: string;
  authorDisplayName: string;
  taggedName: string;
  /** Only present when the post is Public. */
  snippet?: string | null;
  alreadyClaimed: boolean;
}

const readError = async (res: Response, fallback: string): Promise<string> => {
  try {
    const body = await res.json();
    if (typeof body?.error === 'string') return body.error;
  } catch { /* not JSON */ }
  return fallback;
};

export const tagInviteService = {
  /** The author's own claim codes for the not-yet-members tagged in one post. */
  getMine: async (postId: string): Promise<TagInviteLink[]> => {
    const res = await fetch(`${API_BASE_URL}/tag-invites/post/${encodeURIComponent(postId)}`, {
      headers: { ...authService.getAuthHeaders() },
    });
    if (!res.ok) throw new Error('Could not load your invite links');
    return res.json();
  },

  /** Public — what the landing page shows before anyone signs in. */
  preview: async (postId: string, tagId: string, code: string): Promise<TagInvitePreview> => {
    const res = await fetch(`${API_BASE_URL}/tag-invites/${encodeURIComponent(postId)}/${encodeURIComponent(tagId)}/${encodeURIComponent(code)}`);
    if (!res.ok) throw new Error(await readError(res, "This tag link isn't valid."));
    return res.json();
  },

  claim: async (postId: string, tagId: string, code: string): Promise<{ postId: string }> => {
    const res = await fetch(`${API_BASE_URL}/tag-invites/${encodeURIComponent(postId)}/${encodeURIComponent(tagId)}/${encodeURIComponent(code)}/claim`, {
      method: 'POST',
      headers: { ...authService.getAuthHeaders() },
    });
    if (!res.ok) throw new Error(await readError(res, 'Could not claim this tag.'));
    return res.json();
  },
};
